import { GlobalState } from "../global.store";

export const selectBannerAds = (state: GlobalState) => {
  return state.bannerAds;
};
